import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs/internal/Observable";
import { DashboardDTO } from "../schema/Dashboard/DashboardDTO";

@Injectable({
    providedIn: "root"
})
export class ApiDashboardService {
    urlApi: string;

    constructor(private _http: HttpClient) {
        this.urlApi = `${environment.admin.url}/api/v1/dashboard`;
    }

    public GetUrl(sigla: string, filter: Array<{ key: string; value: string }> = null): Observable<string> {
        let queryString = null;

        if (filter != null && filter.length > 0) {
            queryString = filter
                .filter((a) => a.value != null && a.value != "")
                .map((element) => {
                    return element.key + "=" + element.value;
                })
                .join("&");
        }
        return this._http.get<string>(
            this.urlApi + "/" + sigla + "/url" + (queryString != null ? "?" + queryString : "")
        );
    }

    public Get(sigla: string): Observable<DashboardDTO> {
        return this._http.get<DashboardDTO>(this.urlApi + "/" + sigla);
    }

    public GetList(): Observable<DashboardDTO[]> {
        return this._http.get<DashboardDTO[]>(this.urlApi);
    }
}
